import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';

async function getUsersBySubscriptionId(
  subscriptionId: string
): Promise<UserDoc[]> {
  try {
    const db = firestore;
    const usersCollection = collection(db, FirestoreCollections.users);
    const results = await getDocs(
      query(
        usersCollection,
        orderBy(`id_subscription.${subscriptionId}.roles`, 'asc')
      )
    );

    const users: UserDoc[] = [];

    results.docs.forEach((doc) => {
      users.push(UserDoc.fromFirestore(doc));
    });

    return users;
  } catch (e) {
    console.log('error: ', e);
    throw new GetUsersBySubscriptionIdFailure();
  }
}

export class GetUsersBySubscriptionIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUsersBySubscriptionId;
